import { useState } from 'react'
import { BotsPage } from './components/BotsPage'
import { LedgerPage } from './components/LedgerPage'
import { MarketPage } from './components/MarketPage'
import { PnLPage } from './components/PnLPage'
import { StatusBar } from './components/StatusBar'
import { TabBar } from './components/TabBar'
import { TradePage } from './components/TradePage'
import { MOBIL_SAYFALAR, type PageId } from './pages'
import { useIsMobile } from './useMediaQuery'
import { useMarketData } from './useMarketData'
import { useMarketSocket } from './useMarketSocket'
import { useNow } from './useNow'

export default function App() {
  const { state, select } = useMarketSocket()
  const marketData = useMarketData()
  const now = useNow()
  const [page, setPage] = useState<PageId>('market')
  const mobil = useIsMobile()

  // `trade` ve `bots` yalnız mobilde var olan sayfalar. Pencere genişleyince
  // kullanıcı boş ekranla kalmasın diye masaüstünde `market`e düşüyorlar —
  // orada emir defteri, giriş formu ve bot listesi zaten aynı ızgarada.
  const aktif: PageId = !mobil && MOBIL_SAYFALAR.has(page) ? 'market' : page

  // Kontrat seçmek mobilde İşlem ekranına GÖTÜRÜR: telefonda satıra dokunmak
  // "bunu incele" demek ve listede kalmanın bir anlamı yok. Masaüstünde seçim
  // yerinde kalıyor, iki panel zaten yan yana.
  const kontratSec = (contract: string) => {
    select(contract)
    if (mobil) setPage('trade')
  }

  // Soket App seviyesinde: sayfa değiştirmek bağlantıyı koparmıyor, geri
  // dönüldüğünde tahta dolu geliyor.
  return (
    <div className="app">
      <StatusBar
        connected={state.connected}
        health={state.health}
        page={aktif}
        onNavigate={setPage}
      />

      {aktif === 'market' && (
        <MarketPage
          state={state}
          marketData={marketData}
          now={now}
          onSelect={kontratSec}
          mobil={mobil}
        />
      )}
      {aktif === 'trade' && <TradePage state={state} now={now} />}
      {aktif === 'bots' && <BotsPage contracts={state.contracts} selected={state.selected} />}
      {aktif === 'pnl' && <PnLPage />}
      {aktif === 'ledger' && <LedgerPage />}

      {/* Mobil navigasyon. Masaüstünde CSS ile gizli — üst şeritteki menü
          devrede. Sayfa içeriğinden SONRA geliyor: hem görsel sıra (en altta)
          hem de klavyeyle gezinme sırası doğru olsun. */}
      <TabBar page={aktif} onNavigate={setPage} />
    </div>
  )
}
